import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "8ec3887d-10c9-4920-89da-a989ffcb88b7", content: "The lowest audible frequency.", options: {} },
  {
    id: "1b8c1826-9474-4aef-bbbb-42cc6b9d1325",
    content: "The commonly used fastest temporal modulation in speech.",
    options: {},
  },
  { id: "1f35df95-f086-487e-b06e-8816037c3602", content: "The fastest temporal modulation of speech.", options: {} },
  { id: "20961afd-50ef-4d6e-9a58-36bdb0943217", content: "The slowest temporal modulation of speech.", options: {} },
];

export const task: Task = {
  id: "879cd529-a5fc-4ed0-9022-48f4ae9e98ba",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["8ec3887d-10c9-4920-89da-a989ffcb88b7", "1b8c1826-9474-4aef-bbbb-42cc6b9d1325"],
};
